import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.push.js";
import { asyncRouterHandle } from '@/utils/asyncRouter';
import { asyncMenu } from '@/api/menu';
var routerList = [];
var formatRouter = function formatRouter(routes) {
  routes && routes.map(function (item) {
    if ((!item.children || item.children.every(function (ch) {
      return ch.hidden;
    })) && item.name != '404') {
      routerList.push({
        label: item.meta.title,
        value: item.name
      });
    }
    if (item.children && item.children.length > 0) {
      formatRouter(item.children);
    }
  });
};
export var router = {
  namespaced: true,
  state: {
    asyncRouters: [],
    routerList: routerList
  },
  mutations: {
    setRouterList: function setRouterList(state, routerList) {
      state.routerList = routerList;
    },
    // 设置动态路由
    setAsyncRouter: function setAsyncRouter(state, asyncRouters) {
      state.asyncRouters = asyncRouters;
    }
  },
  actions: {
    // 从后台获取动态路由
    SetAsyncRouter: function SetAsyncRouter(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, baseRouter, asyncRouterRes, asyncRouter;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              baseRouter = [{
                path: '/layout',
                name: 'layout',
                component: "view/layout/index.vue",
                meta: {
                  title: "底层layout"
                },
                children: []
              }];
              _context.next = 4;
              return asyncMenu();
            case 4:
              asyncRouterRes = _context.sent;
              if (!(asyncRouterRes.code != 0)) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return");
            case 7:
              asyncRouter = asyncRouterRes.data && asyncRouterRes.data.menus;
              console.log("asyncRouter", asyncRouter);
              asyncRouter.push({
                path: "404",
                name: "404",
                hidden: true,
                meta: {
                  title: "迷路了*。*"
                },
                component: 'view/error/index.vue'
              });
              formatRouter(asyncRouter);
              baseRouter[0].children = asyncRouter;
              baseRouter.push({
                path: '*',
                redirect: '/layout/404'
              });
              asyncRouterHandle(baseRouter);
              commit('setAsyncRouter', baseRouter);
              commit('setRouterList', routerList);
              return _context.abrupt("return", true);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  getters: {
    // 获取动态路由
    asyncRouters: function asyncRouters(state) {
      return state.asyncRouters;
    },
    routerList: function routerList(state) {
      return state.routerList;
    },
    defaultRouter: function defaultRouter(state) {
      return state.defaultRouter;
    }
  }
};